import { jsxs, jsx } from "react/jsx-runtime";
const VisualisationTableIcon = (props) => /* @__PURE__ */ jsxs("svg", { ...props, viewBox: "0 0 1024 1024", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M136 136V888H888V136H136ZM96 64C78.3269 64 64 78.3269 64 96V928C64 945.673 78.3269 960 96 960H928C945.673 960 960 945.673 960 928V96C960 78.3269 945.673 64 928 64H96Z",
      fill: "black",
      fillOpacity: "0.65"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M200 236C200 218.327 214.327 204 232 204H333C350.673 204 365 218.327 365 236V244C365 261.673 350.673 276 333 276H232C214.327 276 200 261.673 200 244V236Z",
      fill: "#0A3A83"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M429 236C429 218.327 443.327 204 461 204H563C580.673 204 595 218.327 595 236V244C595 261.673 580.673 276 563 276H461C443.327 276 429 261.673 429 244V236Z",
      fill: "#0A3A83"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M659 236C659 218.327 673.327 204 691 204H792C809.673 204 824 218.327 824 236V244C824 261.673 809.673 276 792 276H691C673.327 276 659 261.673 659 244V236Z",
      fill: "#0A3A83"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M659 644C659 626.327 673.327 612 691 612H792C809.673 612 824 626.327 824 644V652C824 669.673 809.673 684 792 684H691C673.327 684 659 669.673 659 652V644Z",
      fill: "#5CBAEB"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M200 372C200 354.327 214.327 340 232 340H333C350.673 340 365 354.327 365 372V380C365 397.673 350.673 412 333 412H232C214.327 412 200 397.673 200 380V372Z",
      fill: "#5CBAEB"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M429 372C429 354.327 443.327 340 461 340H563C580.673 340 595 354.327 595 372V380C595 397.673 580.673 412 563 412H461C443.327 412 429 397.673 429 380V372Z",
      fill: "#5CBAEB"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M200 508C200 490.327 214.327 476 232 476H333C350.673 476 365 490.327 365 508V516C365 533.673 350.673 548 333 548H232C214.327 548 200 533.673 200 516V508Z",
      fill: "#5CBAEB"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M429 508C429 490.327 443.327 476 461 476H563C580.673 476 595 490.327 595 508V516C595 533.673 580.673 548 563 548H461C443.327 548 429 533.673 429 516V508Z",
      fill: "#5CBAEB"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M200 644C200 626.327 214.327 612 232 612H333C350.673 612 365 626.327 365 644V652C365 669.673 350.673 684 333 684H232C214.327 684 200 669.673 200 652V644Z",
      fill: "#5CBAEB"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M429 644C429 626.327 443.327 612 461 612H563C580.673 612 595 626.327 595 644V652C595 669.673 580.673 684 563 684H461C443.327 684 429 669.673 429 652V644Z",
      fill: "#5CBAEB"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M200 780C200 762.327 214.327 748 232 748H333C350.673 748 365 762.327 365 780V788C365 805.673 350.673 820 333 820H232C214.327 820 200 805.673 200 788V780Z",
      fill: "#5CBAEB"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M429 780C429 762.327 443.327 748 461 748H563C580.673 748 595 762.327 595 780V788C595 805.673 580.673 820 563 820H461C443.327 820 429 805.673 429 788V780Z",
      fill: "#5CBAEB"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M659 372C659 354.327 673.327 340 691 340H792C809.673 340 824 354.327 824 372V380C824 397.673 809.673 412 792 412H691C673.327 412 659 397.673 659 380V372Z",
      fill: "#5CBAEB"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M659 508C659 490.327 673.327 476 691 476H792C809.673 476 824 490.327 824 508V516C824 533.673 809.673 548 792 548H691C673.327 548 659 533.673 659 516V508Z",
      fill: "#5CBAEB"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M659 780C659 762.327 673.327 748 691 748H792C809.673 748 824 762.327 824 780V788C824 805.673 809.673 820 792 820H691C673.327 820 659 805.673 659 788V780Z",
      fill: "#5CBAEB"
    }
  )
] });
export {
  VisualisationTableIcon
};
